import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="heading01 type01">
        <h1>{{ 'events.Notifications' | translate }}</h1>
        <a class="btn add" ui-sref="authorized.events.add()">{{ 'general.Create new' | translate }}</a>
    </div>
    <div class="table-filters">
        <form ng-submit="vm.applyFilter()" class="form form-filter">
            <div class="fields">
                <div class="row row-md">
                    <label class="label">{{ 'filter.Name' | translate }}</label>
                    <div class="items">
                        <input ng-model="vm.filter.name" type="text" class="form-control">
                    </div>
                </div>
                <div class="row row-md row-flex02">
                    <label class="label">{{ 'events.Trigger' | translate }}</label>
                    <div class="items">
                        <div
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.triggerList.options"
                            selected-model="vm.multiFilter.triggerList.model"
                            extra-settings="vm.multiFilter.triggerList.settings"
                            translation-texts="vm.filterTranslations">
                        </div>
                    </div>
                </div>
                <div class="row row-flex02">
                    <label class="label">{{ 'filter.Status' | translate }}</label>
                    <div class="items">
                        <div
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.statusList.options"
                            selected-model="vm.multiFilter.statusList.model"
                            extra-settings="vm.multiFilter.statusList.settings"
                            translation-texts="vm.filterTranslations">
                        </div>
                    </div>
                </div>
            </div>
            <ul class="actions01">
                <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
            </ul>
        </form>
    </div>

    <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
    <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
        <pagination-tools list="vm.list"></pagination-tools>
        <table class="data01">
            <thead>
                <tr>
                    <th>{{ 'filter.Name' | translate }}</th>
                    <th>{{ 'events.Event' | translate }}</th>
                    <th>{{ 'events.Connected elements' | translate }}</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="item in vm.list.items">
                    <td><a ui-sref="authorized.events.edit({ id: item.id })">{{item.name}}</a> <span ng-if="!item.isActive" class="tag color01">{{ 'user.Inactive' | translate }}</span></td>
                    <td>{{ vm.EVENT_TRIGGER_ENUM.LABELS[item.trigger] }}</td>
                    <td>{{ vm.getConnectedElements(item) }}</td>
                    <td class="actions"><a ng-click="vm.duplicate(item.id)" class="btn ico-copy">
                        {{ 'general.Duplicate' | translate }}</a> <a ng-if="vm.canAdministrate(item)" ng-click="vm.delete(item.id)" class="btn delete">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor ($translate, lodash, toastr, DATATABLES, ListFactory, EventResource, ModalService, USER_STATUS_ENUM,
        EVENT_TRIGGER_ENUM, FilterService, TokenService, PrivilegeService) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.ListFactory = ListFactory;
        this.EventResource = EventResource;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.EVENT_TRIGGER_ENUM = EVENT_TRIGGER_ENUM;
        this.lodash = lodash;
        this.FilterService = FilterService;
        this.filter = {
            expand: 'courses.activeI18n,createdBy'
        };
        this.TokenService = TokenService;
        this.PrivilegeService = PrivilegeService;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.EventResource.query.bind(this.EventResource));
        // we set perPage via pagination to avoid resetting it when using filter
        this.list.pagination.perPage = 25;


        this.initMultiFilter();
        this.filterTranslations = this.FilterService.getTranslations();
        this.applyFilter();
    }

    canAdministrate (event) {
        return this.PrivilegeService.canAdministrateEvents() || event.createdBy.id === this.TokenService.getUser().id;
    }

    initMultiFilter () {
        const activationStatusListOptions = [
            { value: 1, label: this.USER_STATUS_ENUM.LABELS.ACTIVE },
            { value: 0, label: this.USER_STATUS_ENUM.LABELS.INACTIVE }
        ];
        const activationStatusListModel = [activationStatusListOptions[0]];

        const triggerListOptions = [
            {
                value: this.EVENT_TRIGGER_ENUM.KEYS.EMPLOYEE_ENROLLED_TO_COURSE,
                label: this.EVENT_TRIGGER_ENUM.LABELS.EMPLOYEE_ENROLLED_TO_COURSE
            },
            {
                value: this.EVENT_TRIGGER_ENUM.KEYS.EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE,
                label: this.EVENT_TRIGGER_ENUM.LABELS.EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE
            },
            {
                value: this.EVENT_TRIGGER_ENUM.KEYS.TRAINING_EDITED,
                label: this.EVENT_TRIGGER_ENUM.LABELS.TRAINING_EDITED
            },
            {
                value: this.EVENT_TRIGGER_ENUM.KEYS.CERTIFICATE_EXPIRING,
                label: this.EVENT_TRIGGER_ENUM.LABELS.CERTIFICATE_EXPIRING
            }
        ];
        const triggerListModel = [];

        this.multiFilter = {
            statusList: {
                model: activationStatusListModel,
                options: activationStatusListOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            triggerList: {
                model: triggerListModel,
                options: triggerListOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        this.lodash.assign(this.filter, { 'statuses[]': this.multiFilter.statusList.model.map(status => status.value) });
        this.lodash.assign(this.filter, { 'triggers[]': this.multiFilter.triggerList.model.map(trigger => trigger.value) });
        this.list.fetch(this.filter);
    }

    resetFilter () {
        this.filter = {
            expand: 'courses.activeI18n,createdBy'
        };
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
    }

    duplicate (id) {
        this.ModalService.confirm(
            this.$translate.instant('events.Are you sure you wish to duplicate the notification?'),
            'medium')
            .then(() => {
                this.EventResource.duplicate({ id }).$promise.then(() => {
                    this.applyFilter();
                });
            });
    }

    delete (id) {
        this.ModalService.confirm(
            this.$translate.instant('events.Are you sure you wish to delete the notification?'),
            'medium')
            .then(() => {
                this.EventResource.delete({ id }).$promise.then(() => {
                    this.applyFilter();
                });
            });
    }

    getConnectedElements (item) {
        if (item.trigger === this.EVENT_TRIGGER_ENUM.KEYS.CERTIFICATE_EXPIRING) {
            switch (item.action) {
            case 'SEND_NOTIFICATION_FOR_EXTERNAL_COURSES_ONLY':
                return this.$translate.instant('events.All external courses');
            case 'SEND_NOTIFICATION_FOR_INTERNAL_COURSES':
            case 'SEND_NOTIFICATION_FOR_ALL_COURSES':
            default:
                return this.$translate.instant('general.All courses');
            }
        }

        if (!item.courses || item.courses.length === 0) {
            return this.$translate.instant('general.All courses');
        }

        const elements = item.courses.slice(0, 3);
        const connected = elements.map(c => c.activeI18n.name).join(', ');
        return item.courses.length > 3 ? `${connected} ...` : connected;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/events/list/index.js